<template>
    <div class="message message-success" v-bind:class="toggleClass">
        <div class="message-title">
            <div class="message-msg">
                <img v-if="type === 'success'" src="../../../assets/profile/icon_succeed.png">
                <img v-if="type==='error'" src="../../../assets/profile/icon_error.png">

                <slot><p v-if="msg.length > 0">{{msg}}</p></slot>
            </div>
        </div>
    </div>
</template>
<script>

    export default {
        computed: {
            toggleClass () {
                switch (this.type) {
                    case 'success':
                        return 'message-success'
                    case 'error':
                        return 'message-error'
                    default:
                        return 'message-error'
                }
            }
        },
        props: {
            msg: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: 'success'
            }
        }

    }
</script>
<style lang="scss">
    .message {
        &.message-success {
            background-color: #2ECC71;
        }
        &.message-error {
            background-color: #FE3824;
        }
    }

    .message-title {
        height: 80px;
        line-height: 80px;
        .message-msg {
            width: 80%;
            display: flex;
            align-items: center;
            margin: 0 auto;
            p {
                font-size: 22px;
                color: #FFFFFF;
            }
            img {
                margin-right: 15px;
            }
        }

    }
</style>



// WEBPACK FOOTER //
// Message.vue?6c097704